import { IStreamsFilterStoreSegment } from './streamsFilter.interface';

export const streamsFilterStoreSelector = (state: IStreamsFilterStoreSegment) => state.streamsFilter;
